import Link from "next/link";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faRefresh, faInbox } from "@instadeepai/fontawesome-pro-regular";
import { Button } from "@shared/ui";
import { StatusBadge } from "@/components/status-badge";
import { ROUTES } from "@/consts";

export const EmptyModules = () => {
    return (
        <div className="flex flex-col justify-center items-center gap-8">
            <div className="flex flex-col items-center gap-3 text-center">
                <StatusBadge variant="secondary" className="!border-[#F178B6] !text-[#F178B6] !text-sm" leftIcon={<FontAwesomeIcon icon={faInbox} size="1x" />}>
                    Empty
                </StatusBadge>
                <h2 className="font-semibold text-[30px]">No Modules Available</h2>
            </div>
            <div className="flex flex-col gap-1">
                <Link href={ROUTES.MODULES}>
                    <Button variant="primary" rightIcon={<FontAwesomeIcon icon={faRefresh} size="1x" />} >
                        Refresh page
                    </Button>
                </Link>
            </div>
        </div>
    );
}